import React, {
	Component
} from 'react';
import styled from 'styled-components';
import { Button, ButtonBar } from './UI';
import { store } from '../stores/mainStore';

const config = window.dodConfig;

const ScoringPage = styled.div`
	/* margin-top: 35%; */
	box-sizing: border-box;
	width: 100%;
	height: 100%;
	background: rgba(0,0,0, 0.75);
	display: flex;
	justify-content: center;
	align-items: center;
	color: white;
	font-size: 32px;
	pointer-events: auto;
`

const Content = styled.div`
	display: flex;
	width: 80%;
	height: 100%;
	padding-top: ${p => 30}%;
	box-sizing: border-box;
	background-size: 100% auto;
	text-align: center;
	flex-direction: column;
`

const CloseBox = styled.div`
	position: relative;
	display: inline-block;
	width: ${p => config.isLandscape ? 56 : 100}%;
	margin: 0 auto;
`

const BoxContent = styled.img`
	width: 100%;
`

const CloseButton = styled.img`
	width: 15%;
	position: absolute;
	top: -5%;
	right: -5%;
`

const ToSBody = styled.div`
	height: 100vh;
	width: 100vw;
	display: flex;
	flex-direction: column;
	padding-top: 15vw;
`

const ToSButton = styled.button`
	background-color: #ccc;
	color: black;
	padding: 3vw;
	flex: 0 0 3vw;
`

const ToSFrame = styled.iframe`
	flex-grow: 1;
`


export class ModalScoring extends Component {

	continue(){
		store.modal = '';
	}

	learn(){
		window.manager.playAudio("poopPop");
		store.modal = 'learn';
	}
	ranking(){
		store.modal = 'ranking';
	}
	close(){
		window.manager.playAudio("poopPop");
		store.modal = '';
	}
	state = {
		iframe: ""
	}
	closeFaq() {
		window.manager.playAudio("poopPop");
		this.setState({iframe: ""});
	}
	render() {
		if(this.state.iframe){
			return(
				<ToSBody>
					<ToSButton opacity={1} onClick={() => {this.closeFaq()}}>Close</ToSButton>
					<ToSFrame title="terms" src={this.state.iframe}/>
				</ToSBody>
			);
		}
		return (
			<ScoringPage>
				<Content>
					<CloseBox>
						<CloseButton src="/assets/btn_close.png" onClick={e => this.close()}/>
						<BoxContent src={`/assets/languages/${store.settings.language}/scoring_rules.png`}/>
					</CloseBox>
					<ButtonBar>
						<Button faq
							onClick={() => {
								window.manager.playAudio("poopPop");
								this.setState({iframe: "https://www.shakeitupdice.com/gamefaq.html"});
							}}
						/>
						{/* <Button rankings onClick={this.ranking}/> */}
					</ButtonBar>
				</Content>
			</ScoringPage>
		)
	}
}
